/* eslint-disable react/jsx-boolean-value */
import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  CircularProgress,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { makeStyles } from '@mui/styles';
import useGetAllArrowTypes from 'api/locationsCategories/address/useGetAllArrowTypes';
import useAllDecreaseTypes from 'api/locationsCategories/address/useGetAllDecreaseTypes';
import useGetAllLabelTypes from 'api/locationsCategories/address/useGetAllLabelTypes';
import useGetComposeAddressDetails from 'api/locationsCategories/address/useGetComposeAddressDetails';
import useRecomposeAddress from 'api/locationsCategories/address/useRecomposeAddress';
import { MuiRTL } from 'lib/MuiRTL';
import React, { useEffect, useState } from 'react';

const RecomposeAddressModal = props => {
  const { guid, addressGuid } = props;

  const [recomposeLoading, reComposeAddress] = useRecomposeAddress();
  const [detailsLoading, details, getAddressDetails] =
    useGetComposeAddressDetails();
  const [arrowsLoading, arrows, getAllArrowTypes] = useGetAllArrowTypes();
  const [decreasesLoading, decreases, getAllCellDecreaseTypes] =
    useAllDecreaseTypes();
  const [labelsLoading, labels, getAllLabelTypes] = useGetAllLabelTypes();

  const [selectedArrow, setSelectedArrow] = useState();
  const [selectedDecrease, setSelectedDecrease] = useState();
  const [selectedLabel, setSelectedLabel] = useState();
  const [isMixed, setIsMixed] = useState(false);

  useEffect(() => {
    getAllArrowTypes();
    getAllCellDecreaseTypes();
    getAllLabelTypes();
  }, []);

  useEffect(() => {
    getAddressDetails(addressGuid);
  }, [addressGuid]);

  useEffect(() => {
    if (details) {
      setSelectedArrow(details?.arrow);
      setSelectedDecrease(details?.decreaseType);
      setSelectedLabel(details?.labelType);
      setIsMixed(details?.isMixed);
    }
  }, [details]);

  const handleClick = () => {
    reComposeAddress(
      addressGuid,
      {
        arrow: selectedArrow,
        decreaseType: selectedDecrease,
        labelType: selectedLabel,
        isMixed,
      },
      props.refreshData,
    );
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.closeHandler();
        setSelectedArrow('');
        setSelectedDecrease('');
        setSelectedLabel('');
        setIsMixed(false);
      }}
      sx={{ direction: 'rtl' }}
      onKeyDown={handleKeyDown}
    >
      <DialogTitle>ویرایش آدرس</DialogTitle>

      <DialogContent>
        {detailsLoading ||
        arrowsLoading ||
        decreasesLoading ||
        labelsLoading ? (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', minWidth: 300 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ width: 320 }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="arrow-selection">جهت</InputLabel>
              <Select
                labelId="arrow-selection"
                id="arrow-selection-standard"
                value={selectedArrow}
                defaultValue={details?.arrow}
                onChange={e => setSelectedArrow(e.target.value)}
              >
                {arrows
                  ? arrows.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="descrease-selection">نوع خروج</InputLabel>
              <Select
                labelId="descrease-selection"
                id="descrease-selection-standard"
                value={selectedDecrease}
                defaultValue={details?.decreaseType}
                onChange={e => setSelectedDecrease(e.target.value)}
              >
                {decreases
                  ? decreases?.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="labelType-selection">نوع برچسب</InputLabel>
              <Select
                labelId="labelType-selection"
                id="labelType-selection-standard"
                value={selectedLabel}
                defaultValue={details?.labelType}
                onChange={e => setSelectedLabel(e.target.value)}
              >
                {labels
                  ? labels.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="labelType-selection">فضای ترکیبی؟</InputLabel>
              <Select
                labelId="labelType-selection"
                id="labelType-selection-standard"
                value={isMixed}
                defaultValue={details?.isMixed}
                onChange={e => setIsMixed(e.target.value)}
              >
                <MenuItem
                  key={true}
                  value={true}
                  sx={{ justifyContent: 'flex-end' }}
                >
                  بله
                </MenuItem>
                <MenuItem
                  key={false}
                  value={false}
                  sx={{ justifyContent: 'flex-end' }}
                >
                  خیر
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={recomposeLoading}
          //   disabled={!itemName}
          onClick={() =>
            reComposeAddress(
              addressGuid,
              {
                arrow: selectedArrow,
                decreaseType: selectedDecrease,
                labelType: selectedLabel,
                isMixed,
              },
              props.refreshData,
            )
          }
        >
          تایید
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={recomposeLoading}
          onClick={() => {
            props.closeHandler();
            setSelectedArrow('');
            setSelectedDecrease('');
            setSelectedLabel('');
            setIsMixed(false);
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RecomposeAddressModal;
